export const strings = {
  NAME: "Field",
  DESCRIPTION: "Collect various types of information.",
} as const;
